<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>固件更新管理</el-breadcrumb-item>
            <el-breadcrumb-item>固件更新列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="4">
                    <el-input placeholder="请输入设备号" v-model="queryInfo.recordName" clearable @clear="getFrimwareRecordList">
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="请输入固件名" v-model="queryInfo.inputName" clearable @clear="getFrimwareRecordList">
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="请输入版本号" v-model="queryInfo.inputName" clearable @clear="getFrimwareRecordList">
                    </el-input>
                </el-col>
                <el-col :span="6">
                    <el-date-picker
                            style="width: 390px"
                            v-model="queryInfo.searchTime"
                            range-separator="至"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="请选择时间">
                    </el-date-picker>
                </el-col>
                <!--搜索按钮-->
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="getFrimwareRecordList">{{$t('common.search')}}</el-button>
                </el-col>
            </el-row>
            <!--记录区域-->
            <el-table :data="FrimwareRecordList.records" border stripe style="width: 100%" v-loading="loading">
                <el-table-column label="固件版本ID" prop="versionsId" align="center"></el-table-column>
                <el-table-column label="手机设备ID" prop="deviceId" align="center"></el-table-column>
                <el-table-column label="检测设备ID" prop="equipmentId" align="center"></el-table-column>
                <el-table-column label="更新方式" sortable prop="type" align="center"></el-table-column>
                <el-table-column label="更新时间" sortable prop="creationTime" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!--删除-->
                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeFrimwareRecordById(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="FrimwareRecordList.total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "FrimwareRecordList",
        data() {
            return {
                loading:false,
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10
                },
                FrimwareRecordList: {
                    records: [],
                    total: 0
                },
            }
        },
        created() {
            this.getFrimwareRecordList();
        },
        methods: {
            // 获取记录列表
            async getFrimwareRecordList() {
                this.loading = true
                let {data: res} = await this.$http.post(`/frimwarerecord/selectPage`, this.queryInfo);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.FrimwareRecordList.records = res.data.records;
                this.FrimwareRecordList.total = res.data.total;
                this.loading = false
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getFrimwareRecordList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getFrimwareRecordList()
            },
            // 根据id删除记录信息
            async removeFrimwareRecordById(record) {
                // 弹框询问用户是否删除记录
                await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除记录
                    const {data: res} = await this.$http.post(`/frimwarerecord/deleteById`, record);
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取记录列表
                    this.getFrimwareRecordList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
